export function extractAffiliationFromHotlink (hotlink) {
  try {
    const { pathname } = new URL(hotlink)
    return pathname.replace(/^\//, '').split('/')[0] || null
  } catch (error) {
    return null
  }
}

export function normalizeAffiliation (affiliation) {
  if (!affiliation) {
    return null
  }

  if (String(affiliation).includes('://')) {
    return extractAffiliationFromHotlink(affiliation)
  }

  return String(affiliation).replace(/^\//, '')
}

export function getCheckoutOrigin (checkoutBaseUrl = process.env.CHECKOUT_URL) {
  return new URL(checkoutBaseUrl).origin
}

export function buildCheckoutPreviewUrl ({
  affiliation,
  mainOffer,
  activePlatform,
  checkoutBaseUrl = process.env.CHECKOUT_URL,
  parentOrigin = window.location.origin
}) {
  const params = new URLSearchParams()

  if (mainOffer) {
    params.set('off', mainOffer)
  }

  params.set('preview', activePlatform)
  params.set('checkoutMode', '10')
  params.set('parentOrigin', parentOrigin)

  return `${checkoutBaseUrl}${affiliation}?${params.toString()}`
}

export function resolveTemplateKeyFromPayloadItem (templates, { checkoutMode, locale }) {
  const mode = checkoutMode === 1 ? 'mobile' : 'desktop'
  const localeKey = `${mode}-${String(locale).replace('_', '-')}`

  return Object.keys(templates).find(key => key.toLowerCase() === localeKey.toLowerCase()) || null
}
